import React from 'react';
import { Link } from 'react-router-dom';
export function ResourcesSection() {
  return <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-196">
      <div className="grid md:grid-cols-3 gap-6" data-id="element-197">
        <Link to="/recursos-halieuticos" className="relative h-48 rounded-lg overflow-hidden group cursor-pointer" data-id="element-198">
          <img src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=600" alt="Recursos Haliêuticos" className="w-full h-full object-cover" data-id="element-199" />
          <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-6 text-white" data-id="element-200">
            <h3 className="text-xl font-bold mb-2" data-id="element-201">Recursos Haliêuticos</h3>
            <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-202">
              Explorar
            </button>
          </div>
        </Link>
        <div className="relative h-48 rounded-lg overflow-hidden group cursor-pointer" data-id="element-203">
          <img src="https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=600" alt="Aquacultura" className="w-full h-full object-cover" data-id="element-204" />
          <div className="absolute inset-0 bg-blue-900 bg-opacity-60 flex flex-col justify-end p-6 text-white" data-id="element-205">
            <h3 className="text-xl font-bold mb-2" data-id="element-206">Aquacultura</h3>
            <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-207">
              Explorar
            </button>
          </div>
        </div>
        <div className="bg-white rounded-lg p-6 shadow-sm" data-id="element-208">
          <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-209">
            Recursos Haliêuticos
          </h3>
          <p className="text-gray-600 text-sm mb-4" data-id="element-210">
            Informação sobre gestão e conservação dos recursos marinhos
          </p>
          <Link to="/recursos-halieuticos" data-id="element-211">
            <button className="bg-blue-900 text-white px-4 py-1 rounded text-sm font-semibold" data-id="element-212">
              Explorar
            </button>
          </Link>
        </div>
      </div>
    </div>;
}